<template>
  <div class="container p-2">
    <div class="alert alert-primary" role="alert">
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          style="width: 0%"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          0%
        </div>
      </div>
      <h3 class="p-3 text-center">LOGIN</h3>
      <p class="text-center">
        ระบุ เบอร์โทรผู้สมัครสำหรับรับ SMS และรหัสบัตรประจำตัวประชาชน
        สำหรับเป็นรหัสผ่าน
      </p>
    </div>
    <form @submit.prevent="SetStepStatus()">
      <div class="row justify-content-md-center">
        <div class="col-md-6 col-12">
          <div class="alert alert-secondary" role="alert">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1"
                >ปีการศึกษาที่จะสมัคร
              </span>
              <select
                class="form-select"
                aria-label="Default select example"
                name="edu_year"
                id="edu_year"
                v-model="getDataFrom.select_year"
                @change="select_year_All()"
                required
              >
                <option value="" selected disabled>-</option>
                <option
                  v-for="item in getDataYearSignup"
                  :key="item.edu_year"
                  :value="`${item.edu_year}`"
                >
                  {{ item.edu_year }}
                </option>
              </select>
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1"
                >เบอร์โทรผู้สมัคร</span
              >
              <input
                type="text"
                class="form-control IsNumber"
                placeholder="(เฉพาะตัวเลขเท่านั้น) Ex : 091234567"
                aria-label="Username"
                aria-describedby="basic-addon1"
                maxlength="10"
                pattern="[0-9]*"
                name="stu_sms_stu"
                id="stu_sms_stu"
                v-model="getDataFrom.stu_sms_stu"
                required
              />
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1"
                >เลขประจำตัวประชาชน</span
              >
              <input
                type="text"
                class="form-control IsNumber"
                placeholder="(เฉพาะตัวเลขเท่านั้น) Ex : 1509900012345"
                aria-label="Username"
                aria-describedby="basic-addon1"
                maxlength="13"
                name="stu_card_id"
                id="stu_card_id"
                v-model="getDataFrom.stu_card_id"
                required
              />
            </div>
            <div class="row justify-content-md-end">
              <div class="d-inline-flex p-2 justify-content-end">
                <button
                  type="submit"
                  class="btn btn-primary"
                  v-if="getqrcodeChkStatusPay.status != 'Paysuccess'"
                >
                  ขั้นตอนต่อไป <font-awesome-icon :icon="['fas', 'forward']" />
                </button>
              </div>
              <p
                style="
                  text-align: right;
                  padding: 0;
                  margin: 0;
                  margin-right: 10px;
                  font-size: 11px;
                "
              >
                {{ version }}
              </p>
              <!-- {{ this.getDataFrom }} -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div
    class="modal fade"
    role="dialog"
    id="exampleModalPDPA"
    tabindex="-1"
    aria-labelledby="exampleModalLabelPDPA"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      v
      class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ความยินยอมข้อมูลส่วนบุคคลของคุณ</h5>
        </div>
        <div class="modal-body pb-1">
          <p>
            &emsp;&emsp;ด้วยพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. ๒๕๖๒
            เป็นกฎหมายที่มีเจตนารมณ์ปกป้องการล่วงละเมิดและคุ้มครองสิทธิความเป็นส่วนตัวของข้อมูลส่วนบุคคล
            ได้กำหนดหลักการให้การเก็บรวบรวมใช้หรือเปิดเผยข้อมูลส่วนบุคคลจะต้องขอความยินยอมพร้อมทั้งแจ้งวัตถุประสงค์ให้เจ้าของข้อมูลส่วนบุคคลทราบ
            โดยชัดแจ้ง จะทำเป็นหนังสือหรือทำผ่านระบบอิเล็กทรอนิกส์ก็ได้
          </p>
          <p>
            &emsp;&emsp;โดยหนังสือฉบับนี้ วิทยาลัยเทคโนโลยีโปลิเทคนิคลานนา
            (ต่อไปเรียกว่า “วิทยาลัยฯ”) ซึ่งมีภารกิจในด้านการจัดการศึกษา ฝึกอบรม
            การวิจัย และบริหารทางวิชาการและวิชาชีพ
            มีความประสงค์ขอความยินยอมเก็บรวบรวมข้อมูลส่วนบุคคล
            สำหรับผู้ที่เข้ารับการศึกษา ฝึกอบรม
            และผู้ขอรับบริการทางวิชาการและวิชาชีพจากวิทยาลัยฯ
            เพื่อนำไปใช้ประโยชน์ในการดำเนินการจัดการศึกษา ฝึกอบรม
            การวิจัยและบริการทางวิชาการและวิชาชีพ
            ข้าพเจ้าขอให้ความยินยอมในการเก็บรวบรวมใช้
            และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า ดังนี้
          </p>
          <ol>
            <li>
              <p>
                ข้าพเจ้ายินยอม ให้วิทยาลัยฯ เก็บรวบรวมใช้
                หรือเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าที่ได้ให้ไว้โดยตรงในขณะสมัครเข้าศึกษา
                สมัครงาน ลงทะเบียน
                หรือข้อมูลอื่นที่จำเป็นต้องใช้เกี่ยวกับการดำเนินการจัดการศึกษา
              </p>
            </li>
            <li>
              <p>
                ข้าพเจ้ายินยอม ให้วิทยาลัยฯ เก็บรักษาข้อมูลส่วนบุคคลขอข้าพเจ้า
                ตราบเท่าที่วัตถุประสงค์ของการนำข้อมูลดังกล่าวไปใช้ยังคงมีอยู่เว้นแต่กรณีจำเป็นต้องเก็บรักษาไว้ต่อไปตามที่กฎหมายกำหนด
              </p>
            </li>
            <li>
              <p>
                ข้าพเจ้ายินยอม ให้วิทยาลัยฯ และผู้ปฏิบัติงานอื่นของวิทยาลัยฯ
                นำข้อมูลส่วนบุคคลของข้าพเจ้าที่เก็บรวบรวมไปใช้ในการดำเนินการในด้านการจัดการศึกษา
                และกิจการอื่นใดที่เกี่ยวข้องของวิทยาลัย
              </p>
            </li>
            <li>
              <p>
                ข้าพเจ้ายินยอม ให้วิทยาลัยฯ
                เปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าให้แก่หน่วยงานภายนอกตามกฎหมาย
                และหน่วยงานของรัฐ
              </p>
            </li>
            <li>
              <p>วิธีการเพิกถอนความยินยอมและผลการเพิกถอนความยินยอม</p>
            </li>
          </ol>
          <p>
            &emsp;ข้าพเจ้าอาจจเพิกถอนความยินยอมทั้งหมดหรือส่วนใดส่วนหนึ่งตามหนังสือฉบับนี้
            โดยข้าพเจ้าจะแจ้งให้วิทยาลัยฯ ทราบเป็นหนังสือและวิทยาลัยฯ
            อาจขอทราบถึงเหตุผลแห่งการนั้น
          </p>
          <p>
            &emsp;การเพิกถอนความยินยอมของข้าพเจ้าไม่มีผลกระทบต่อการดำเนินการใดๆที่วิทยาลัยฯ
            ได้ดำเนินการไปแล้ว
          </p>
          <p>
            &emsp;ในกรณีที่
            การเพิกถอนความยินยอมเกิดผลกระทบต่อสิทธิหรือหน้าที่ใดๆ ของข้าพเจ้า
            ข้าพเจ้ายอมรับผลกระทบที่เกิดขึ้นจากการนั้นได้
          </p>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-success py-2 px-5"
            @click="accept_pdpa()"
          >
            ยิมยอม
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { RouterLink } from "vue-router";
import { mapGetters } from "vuex";
import { useRoute } from "vue-router";
import $ from "jquery";
import packageInfo from "@/../package.json";

// import CompoStep2 from "../Step2/CompoStep2.vue";
export default {
  data() {
    return {
      selectCard: "",
      version: packageInfo.version,
    };
  },
  async mounted() {
    const route = useRoute();

    if (route.query.from == undefined) {
      const urlparth = window.location.href;
      let splitUrl = urlparth.split("?");
      if (splitUrl[1] != undefined) {
        let frompath = splitUrl[1].replace("#/", "");
        let fullPath = splitUrl[0] + "#/?" + frompath;
        window.location.href = fullPath;
      }
    }

    this.$store.dispatch("Main/SetAdmissionYear");

    this.getDataFrom.linkfrom = route.query.from;
    if (this.getDataFrom.linkfrom == null || this.getDataFrom.linkfrom == "") {
      this.getDataFrom.linkfrom = "website";
    }
    await this.$store.dispatch("Step1/GET_DataYearSignup");
  },
  methods: {
    async accept_pdpa() {
      await this.$store.dispatch("Step1/UPDATE_PDPA");

      if (this.getstatusUpdatePDPA.status == false) {
        await this.$swal({
          icon: this.getstatusUpdatePDPA.type,
          title: this.getstatusUpdatePDPA.alert,
          text: this.getstatusUpdatePDPA.text,
        });
        await $("#exampleModalPDPA").modal("hide");
      } else {
        await $("#exampleModalPDPA").modal("hide");
        await this.SetStepStatus();
      }
    },
    async checkselectCard() {
      if (this.selectCard == "N") {
        await this.$swal({
          icon: "error",
          title: "???",
          text: "ท่านไม่สามารถชำระเงินออนไลน์ได้",
        });
        $("#exampleModal").modal("hide");
      } else if (this.selectCard != "") {
        $("#exampleModal").modal("hide");
        this.SetStepStatus();
      } else {
        await this.$swal({
          icon: "error",
          title: "ผิดพลาด...",
          text: "กรุณาเลือกบัตรประชาชน",
        });
      }
    },
    async select_year_All() {
      this.getDataFrom2.select_year = this.getDataFrom.select_year;
      this.getDataFrom3.select_year = this.getDataFrom.select_year;
      this.getDataFrom4.select_year = this.getDataFrom.select_year;
      this.getDataFrom5.select_year = this.getDataFrom.select_year;
      this.getDataFrom6.select_year = this.getDataFrom.select_year;
    },
    async SetStepStatus() {
      await this.$store.dispatch("Main/SET_Onload", false);
      if (
        this.getDataFrom.stu_sms_stu.length == 10 &&
        this.getDataFrom.stu_card_id.length == 13
      ) {
        await this.$store.dispatch("Step1/postDataPDPA");
        if (this.getDataPDPA == null) {
          await $("#exampleModalPDPA").modal("show");
        } else {
          this.getDataFrom.stu_year_entry = this.getDataFrom.select_year;
          await this.$store.dispatch("Step1/SetStepStatus");
          if (this.tes_id != "") {
            // console.log(this.getDataFrom.tes_id);
            this.getDataFrom2.tes_id = this.tes_id;
            this.getDataFrom3.tes_id = this.tes_id;
            this.getDataFrom4.tes_id = this.tes_id;
            this.getDataFrom5.tes_id = this.tes_id;
            this.getDataFrom6.tes_id = this.tes_id;

            await this.$store.dispatch("Step2/SetStep2");
            // next step
            if (
              this.getDataStepFrom1.Step1 != "" &&
              this.getDataStepFrom1.Step2 != "" &&
              this.getDataStepFrom1.Step3 != "" &&
              this.getDataStepFrom1.Step4 != "" &&
              this.getDataStepFrom1.Step5 != ""
            ) {
              // await this.$store.dispatch("Main/SetStepStatus", 2);
              await this.$store.dispatch("Main/SetStepStatus", 6);
              // await this.$store.dispatch("Main/SET_Onload", true);
            } else if (
              this.getDataStepFrom1.Step1 != "" &&
              this.getDataStepFrom1.Step2 != "" &&
              this.getDataStepFrom1.Step3 != "" &&
              this.getDataStepFrom1.Step4 != ""
            ) {
              // this.$store.dispatch("Main/SetStepStatus", 2);
              await this.$store.dispatch("Main/SetStepStatus", 5);
              await this.$store.dispatch("Main/SET_Onload", true);
            } else if (
              this.getDataStepFrom1.Step1 != "" &&
              this.getDataStepFrom1.Step2 != "" &&
              this.getDataStepFrom1.Step3 != ""
            ) {
              // this.$store.dispatch("Main/SetStepStatus", 2);
              await this.$store.dispatch("Main/SetStepStatus", 4);
              await this.$store.dispatch("Main/SET_Onload", true);
            } else if (
              this.getDataStepFrom1.Step1 != "" &&
              this.getDataStepFrom1.Step2 != ""
            ) {
              // this.$store.dispatch("Main/SetStepStatus", 2);
              await this.$store.dispatch("Main/SetStepStatus", 3);
              await this.$store.dispatch("Main/SET_Onload", true);
            } else if (this.getDataStepFrom1.Step1 != "") {
              await this.$store.dispatch("Main/SetStepStatus", 2);
              await this.$store.dispatch("Main/SET_Onload", true);
            } else {
              // await this.$swal({
              //   icon: "error",
              //   title: "ผิดพลาด...",
              //   text: "ไม่สามารถเข้าสู่ระบบได้ กรุณาติดต่อที่แฟนเพจ Facebook : วิทยาลัยเทคโนโลยีโปลิเทคนิคลานนา",
              // });
              await this.$store.dispatch("Main/SetStepStatus", 2);
              await this.$store.dispatch("Main/SET_Onload", true);
            }
          } else {
            await this.$swal({
              icon: "error",
              title: "ผิดพลาด...",
              text: this.getDataStepFrom1.statusTxt,
            });
          }
        }
      } else {
        //console.log("SetStepStatus" + this.DataFrom);
        await this.$swal({
          icon: "error",
          title: "กรุณาระบุข้อมูล...",
          text: "เบอร์โทรสำหรับรับ SMS และหมายเลขบัตรประจำตัวประชาชน ของผู้สมัคร",
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      AdmissionYear: "Main/_getAdmissionYear",
      tes_id: "Main/_getTesID",
      getDataFrom: "Step1/_getDataFrom",
      getDataFrom2: "Step2/_getDataFrom2",
      getDataFrom3: "Step3/_getDataFrom3",
      getDataFrom4: "Step4/_getDataFrom4",
      getDataFrom5: "Step5/_getDataFrom5",
      getDataFrom6: "Step6/_getDataFrom6",
      getDataStepFrom1: "Step1/_getDataStepFrom1",
      getqrcodeChkStatusPay: "Step6/_getqrcodeChkStatusPay",
      getDataYearSignup: "Step1/_getDataYearSignup",
      getDataPDPA: "Step1/_getDataPDPA",
      getstatusUpdatePDPA: "Step1/_getstatusUpdatePDPA",
    }),
  },
};
</script>

<style>
p {
  text-align: justify;
}
</style>
